/*
 * Copyright 2025 Intuition Robotics ltd
 */
import type {PsychologicalQuestion} from "./patient-data.js";

export const PHQQuestions: PsychologicalQuestion[] = [
	{
		key: "little_interest_frequency",
		description: "Little interest or pleasure in doing things"
	},
	{
		key: "feeling_down_frequency",
		description: "Feeling down, depressed, or hopeless"
	}
];